(function () {
  const sectionInstances = new WeakMap();

  function destroyPanelCarousel(panel) {
    const carousel = panel.querySelector('[data-infinite-carousel]');
    if (carousel && window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.destroy(carousel);
    }
  }

  function initPanelCarousel(panel) {
    const carousel = panel.querySelector('[data-infinite-carousel]');
    if (!carousel || carousel.dataset.carouselEnabled === 'false') return;

    if (window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.init(carousel);
    }
  }

  function activateTab(section, tabIndex) {
    const tabs = [...section.querySelectorAll('[data-top-products-tab]')];
    const panels = [...section.querySelectorAll('[data-top-products-panel]')];

    tabs.forEach((tab, index) => {
      const isActive = index === tabIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel, index) => {
      const isActive = index === tabIndex;

      if (isActive) {
        panel.hidden = false;
        panel.classList.add('is-active');
        requestAnimationFrame(() => initPanelCarousel(panel));
      } else {
        destroyPanelCarousel(panel);
        panel.hidden = true;
        panel.classList.remove('is-active');
      }
    });
  }

  function initSection(section) {
    if (sectionInstances.has(section)) {
      sectionInstances.get(section)();
    }

    const tabs = [...section.querySelectorAll('[data-top-products-tab]')];
    const panels = [...section.querySelectorAll('[data-top-products-panel]')];

    const tabHandlers = tabs.map((tab) => {
      const onClick = () => {
        const tabIndex = parseInt(tab.dataset.tabIndex, 10) || 0;
        activateTab(section, tabIndex);
      };

      tab.addEventListener('click', onClick);
      return { tab, onClick };
    });

    panels.forEach((panel) => destroyPanelCarousel(panel));

    const activePanel = panels.find((panel) => panel.classList.contains('is-active')) || panels[0];
    if (activePanel) {
      requestAnimationFrame(() => initPanelCarousel(activePanel));
    }

    const scrollContainer = section.querySelector('[data-top-products-tabs-scroll]');
    if (scrollContainer) {
      scrollContainer.scrollLeft = 0;
    }

    const destroy = () => {
      tabHandlers.forEach(({ tab, onClick }) => tab.removeEventListener('click', onClick));
      panels.forEach((panel) => destroyPanelCarousel(panel));
      sectionInstances.delete(section);
    };

    sectionInstances.set(section, destroy);
  }

  function destroySection(section) {
    if (sectionInstances.has(section)) {
      sectionInstances.get(section)();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="top-products-tab"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="top-products-tab"]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="top-products-tab"]');
    if (section) destroySection(section);
  });
})();
